var MessagesAPI = require('../../common/api').Messages;
var ApplicationAPI = require("../../common/api").Application;
var _ = require('underscore');
var moment = require("moment");

module.exports = function MessagesController($scope, $state, $interval, ngDialog, $rootScope) {
  var vm = this;
  vm.filterText = '';
  vm.conversations = [];


  $scope.create = function () {
    var dialog = ngDialog.open({
      template: require('./dialogs/new-message.pug')(),
      controller: require('./dialogs/new-message.js'),
      controllerAs: 'vm',
      plain: true,
      disableAnimation: true,
    });

    dialog.closePromise.then(function(data) {
      if (data.value && data.value != "$document" && data.value != "closeButton"){
        ApplicationAPI.Begin($scope.applicant.id, data.value.projectTitle, data.value.seekingPublicFunding, data.value.seekingTrustFunding, data.value.specificTrustForFundingId).then(function(resp){
          $state.go('applicant.application', {id: resp});
        })
      }
    });
  }

  vm.viewThread = function(id) {
    vm.currentThread = id;
  }

  vm.filterConversations = function(){
    return vm.tick();
  }

  vm.tick = function(){
    return MessagesAPI.GetConversations(vm.filterText).then(function(result){
      vm.conversations = result;
      vm.conversations.forEach( function(item) {
        ApplicationAPI.Get(item.applicationId, "UserApplicationDetailsView").then(function(result) {
          item.applicationName = result.projectTitle;
        });
      })

      // if no thread selected, and there are some results.
      if (!vm.currentThread && vm.conversations.length) {
        vm.currentThread = vm.conversations[0].conversationId;
      }
    })
  }

  vm.getProjectUrl = function(applicationId) {
    var url = "";
    if($rootScope.auth){
      $rootScope.auth.claims.forEach( function(claim) {
        if( claim.type =="ApplicantAdmin") {
          url = "/applicant/dashboard/projects/" + applicationId;
        } else if (claim.type == "FunderMember") {
          url = "/funder/dashboard/applications/" + applicationId;
        }
      })
    }
    return url;
  }

  $interval(vm.tick, 60000);
  vm.tick();

  // function setSelectedConversation(runViewThread){
  //   _.each(vm.conversations, function(c){
  //     //if nothing selected, select first one
  //     if(!vm.messageListConversationId){
  //       c.isSelected = true;
  //       vm.messageListConversationId = c.conversationId;
  //       //run view thread only required on initialise, to display default message selection
  //       if(runViewThread){
  //         viewThread(c.conversationId);
  //       }
  //     }
  //     else if(vm.messageListConversationId == c.conversationId){
  //       c.isSelected = true;
  //     } else{
  //       c.isSelected = false;
  //     }
  //   });
  // }
}
